"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessageField = SendMessageField;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
function SendMessageField({ messageRules }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "message", label: intl.formatMessage({
            id: 'offer_detail.send_resume_form.message',
        }), rules: messageRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input.TextArea, { rows: 4 }) }));
}
